import React from 'react'
import { FormControl, Grid, InputLabel, MenuItem, Select, Button } from '@mui/material'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import AutoCompleteHomePage from './AutoCompleteHomePage';


const STHomePageModal = ({
    open,
    fields,
    onClose,
    inputRef,
    changeHandler,
    options,
    autoCompleteOptions,
    autoCompleteLoading,
    handleAddModalFormData,
    handleChangeAutoComplete,
    handleSearchValueAutoComplete,
}) => {

  return (
    <Dialog closeAfterTransition={false} fullWidth maxWidth={'md'} open={open} onClose={onClose}>
        <DialogTitle> STHome Page </DialogTitle>
        <DialogContent>
            <Grid container direction="row" spacing={2}>
                <Grid item xs={12} sm={6} md={6}>
                    <FormControl
                        margin="dense"
                        fullWidth
                    >
                        <InputLabel id="demo-simple-select-standard-label">Sheet</InputLabel>
                        <Select
                            labelId="demo-simple-select-standard-label"
                            id="demo-simple-select-standard"
                            sx={{
                                "&:focus": {
                                    backgroundColor: "#ffffff"
                                }
                            }}
                            label="Sheet"
                            value={fields.Sheet || ''}
                            onChange={(event) => changeHandler(event.target.name,event.target.value)}
                            name="Sheet"
                        >
                            <MenuItem value="">Select Sheet</MenuItem>
                            {options?.map((opt) => (
                                <MenuItem key={opt.value} value={opt.value}>{opt.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                    <AutoCompleteHomePage
                        label="Search Text"
                        options={autoCompleteOptions}
                        loading={autoCompleteLoading}
                        handleChangeAutoComplete={handleChangeAutoComplete}
                        inputRef={inputRef}
                        handleSearchValueAutoComplete={handleSearchValueAutoComplete} />
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button 
                variant="contained"
                size="medium"
                color="primary" 
                onClick={handleAddModalFormData}
            >Submit</Button>
            <Button 
                variant="contained"
                size="medium"
                color="error" 
                onClick={onClose}
            >Close</Button>
        </DialogActions>
    </Dialog>
  )
}

export default STHomePageModal